import React, { useState } from 'react';
import useProducts from '../../../hooks/use-products';
import BookstoreProductGrid from '../../@bookstore/bookstore-product-grid';

interface Props {
  value: string;
  isRetailer: boolean;
}

const SearchProductResults: React.FC<Props> = ({ value, isRetailer }) => {
  const [pageIndex, setPageIndex] = useState(1);

  let purchaseOptions: any[] = [];

  if (isRetailer) {
    purchaseOptions = [
      { code: 'purchaseoption', namespace: '', value: 'internal_access' },
      { code: 'purchaseoption', namespace: '', value: 'off' },
    ];
  } else {
    purchaseOptions = [
      { code: 'purchaseoption', namespace: '', value: 'consumer' },
      { code: 'purchaseoption', namespace: '', value: 'internal_access' },
      { code: 'purchaseoption', namespace: '', value: 'off' },
    ];
  }

  const { data, loading, error } = useProducts({
    conditions: [
      { code: '_search', namespace: '', value: value },
      { code: 'siteSearch', namespace: '', value: '' },
      ...purchaseOptions,
    ],
    page: pageIndex - 1,
    size: 12,
  });

  const component = (children) => (
    <section className="search-product-results">
      <h3>Products</h3>
      {children}
      {/* language=CSS */}
      <style jsx>{`
        section {
          margin-bottom: 2rem;
        }

        h3 {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 500;
          margin: 0 0 0.5rem;
        }

        .search-product-results :global(p) {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin: 0;
        }
      `}</style>
    </section>
  );

  if (loading || error) {
    return component(<p>Search...</p>);
  }

  if (!data || data.products.content.length === 0) {
    return component(
      <p>
        Your search did not return any matching products. Please try a different
        search.
      </p>
    );
  }

  return component(
    <BookstoreProductGrid
      products={data.products}
      pageIndex={pageIndex}
      setPageIndex={setPageIndex}
      showPagination={true}
    />
  );
};

export default SearchProductResults;
